import React from 'react';
import {FontAwesomeIcon, FontAwesomeIconProps} from "@fortawesome/react-fontawesome";
import BaseProps from "../types/BaseProps";
import classNames from "classnames";

export type IconProps = FontAwesomeIconProps & BaseProps & { disabled?: boolean };

/**
 * Wrapper around FontAwesomeIcon.
 */
class Icon extends React.Component<IconProps> {

  render() {
    const classes = classNames("Icon", this.props.className, {
      'fa-disabled': this.props.disabled
    });
    return <FontAwesomeIcon {...this.props} className={classes}/>;
  }

}

export default Icon;
